import React from 'react';

export default function StudioMoreInformation() {
	return (
		<React.Fragment>
			<header className="l-margin-bottom--l">
				<h2 className="text--title text--bold text--tight">Get more information</h2>
				<h3 className="text--small-title text-color--darkest72">Visit the Studio forum or contact us</h3>
			</header>

			<div className="studio-landing__more-info-card-container">
				<article className="card">
					<div className="card__internal studio-landing__more-info-card">
						<div className="studio-landing__more-info-card-image">
							{renderDiscussionIcon()}
						</div>
						<div className="studio-landing__more-info-card-text">
							<p><a className="studio-landing__more-info-card-link" href="https://forum.bricklink.com/" target="_blank">Discuss various topics</a> with over 100,000 members in our community. </p>
						</div>
					</div>
				</article>
				<article className="card">
					<div className="card__internal studio-landing__more-info-card">
						<div className="studio-landing__more-info-card-image">
							{renderContactIcon()}
						</div>
						<div className="studio-landing__more-info-card-text">
							<p>If you need further assistance, use our <a className="studio-landing__more-info-card-link" href="https://www.bricklink.com/helpDesk.asp" target="_blank">contact form</a> to get in touch.</p>
						</div>
					</div>
				</article>
			</div>
		</React.Fragment>
	);
}


function renderDiscussionIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="37"
			height="28"
			fill="none"
			viewBox="0 0 37 28"
		>
			<title>Conversation bubbles with a question mark inside</title>
			<path
				fill="#fff"
				d="M1.286 3.712c0-1.874 1.499-3.426 3.426-3.426h15.42c1.873 0 3.426 1.552 3.426 3.426v10.28a3.416 3.416 0 01-3.427 3.426h-8.03l-4.337 3.266c-.268.214-.59.214-.91.107-.268-.16-.429-.428-.429-.803v-2.57H4.712c-1.927 0-3.426-1.5-3.426-3.426V3.712zm13.706 15.42h5.14a5.141 5.141 0 005.139-5.14V7.139h6.853c1.874 0 3.426 1.552 3.426 3.426v10.28a3.416 3.416 0 01-3.426 3.426H30.41v2.57c0 .375-.215.642-.482.803-.321.107-.643.107-.91-.107l-4.337-3.266h-6.264c-1.927 0-3.426-1.5-3.426-3.427v-1.713zM8.567 5.264l-.054.053c-.16.536.107 1.178.696 1.339.536.214 1.125-.054 1.339-.643v-.053c.053-.16.214-.214.375-.214h2.57c.374 0 .695.267.695.642 0 .268-.16.482-.32.589l-1.982 1.178c-.374.16-.535.535-.535.91v.589c0 .589.482 1.07 1.07 1.07.536 0 1.018-.481 1.071-1.07l1.392-.803c.91-.482 1.446-1.446 1.446-2.463 0-1.553-1.285-2.784-2.838-2.784h-2.57c-1.07 0-2.034.642-2.355 1.66zm5.247 8.298c0-.75-.643-1.392-1.392-1.392-.803 0-1.446.643-1.446 1.392a1.44 1.44 0 001.446 1.446c.75 0 1.392-.643 1.392-1.446z"
			></path>
			<path
				fill="#F7D117"
				fillRule="evenodd"
				d="M3 3.714A2.286 2.286 0 00.714 6V17.43A2.286 2.286 0 003 19.714h2.857v2.42c0 .444.485.718.866.49l4.848-2.91h6.858a2.286 2.286 0 002.285-2.285V6a2.286 2.286 0 00-2.285-2.286H3z"
				clipRule="evenodd"
			></path>
			<path
				fill="#2C2E35"
				d="M13 11.857c-.592 0-1.072.48-1.072 1.072 0 .589.434 1.07 1.072 1.07.637 0 1.071-.479 1.071-1.07 0-.638-.482-1.072-1.071-1.072zm.89-8.143h-1.95A2.37 2.37 0 009.57 6.082a.857.857 0 101.715 0c0-.359.294-.654.653-.654h1.948a.826.826 0 01.36 1.57l-1.644.852c-.284.102-.46.44-.46.76v1.104a.86.86 0 00.857.857.86.86 0 00.857-.862V9.13l1.167-.606c.82-.428 1.404-1.3 1.404-2.27 0-1.4-1.14-2.54-2.539-2.54zm18.824 3.429h-6.857v1.714h6.857c.945 0 1.714.77 1.714 1.714v10.286c0 .945-.769 1.714-1.714 1.714h-3.428v2.656l-4.693-2.656H19c-.945 0-1.715-.769-1.715-1.714v-1.714h-1.714v1.713c0 1.888 1.54 3.38 3.38 3.38l5.192.05 5.834 3.301c.117.09.251.127.38.127a.638.638 0 00.643-.643v-2.787h1.714c1.889 0 3.429-1.54 3.429-3.38v-10.38c0-1.844-1.538-3.381-3.429-3.381zM24.143 14V3.666c0-1.84-1.538-3.38-3.429-3.38H5.286c-1.889 0-3.43 1.54-3.43 3.38v10.286c0 1.939 1.541 3.476 3.43 3.476L7 17.43v2.785a.641.641 0 001.024.516l5.833-3.302 6.857-.004A3.43 3.43 0 0024.143 14zm-10.736 1.714l-4.693 2.657v-2.657H5.285A1.718 1.718 0 013.571 14V3.714C3.571 2.77 4.341 2 5.285 2h15.43c.944 0 1.713.77 1.713 1.714V14c0 .945-.769 1.714-1.714 1.714h-7.307z"
			></path>
		</svg>
	);
}

function renderContactIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="36"
			height="28"
			fill="none"
			viewBox="0 0 36 28"
		>
			<title>Person with a conversation bubble</title>
			<g clipPath="url(#clip0_603_2035)">
				<path
					fill="#fff"
					d="M19.714 7.143c0 3.787-3.07 6.857-6.906 6.857-3.74 0-6.857-3.07-6.857-6.857 0-3.787 3.118-6.857 6.857-6.857 3.836 0 6.906 3.07 6.906 6.857zM15.572 16.571H10.14c-5.126 0-9.284 4.157-9.284 9.284 0 1.026.832 1.858 1.857 1.858h20.288a1.853 1.853 0 001.855-1.858 9.285 9.285 0 00-9.284-9.284z"
				></path>
				<path
					fill="#F7D117"
					fillRule="evenodd"
					d="M21.427 3.143c-.63 0-1.142.512-1.142 1.143v8c0 .631.511 1.143 1.142 1.143h1.143v1.714c0 .47.538.74.915.457l2.514-1.886v-.285h5.143c.631 0 1.143-.512 1.143-1.143v-8c0-.631-.512-1.143-1.143-1.143h-9.715z"
					clipRule="evenodd"
				></path>
				<path
					fill="#2C2E35"
					d="M19.714 7.143c0 3.787-3.07 6.857-6.906 6.857-3.74 0-6.857-3.07-6.857-6.857 0-3.787 3.118-6.857 6.857-6.857 3.836 0 6.906 3.07 6.906 6.857zm-12.049 0a5.144 5.144 0 005.143 5.143 5.114 5.114 0 005.143-5.143A5.113 5.113 0 0012.808 2a5.143 5.143 0 00-5.143 5.143zm17.877 8.486a.44.44 0 01-.45.042.437.437 0 01-.236-.385v-3H24a2.572 2.572 0 01-2.571-2.572V2.857A2.572 2.572 0 0123.999.286h8.572a2.572 2.572 0 012.571 2.571v6.857a2.572 2.572 0 01-2.571 2.572h-2.572l-4.457 3.343zm7.029-5.058a.86.86 0 00.857-.857V2.857A.858.858 0 0032.57 2h-8.572a.858.858 0 00-.857.857v6.857a.86.86 0 00.857.857h2.572v2.143l2.855-2.143h3.145zM15.572 16.571H10.14c-5.126 0-9.284 4.157-9.284 9.284 0 1.026.832 1.858 1.857 1.858h20.288a1.853 1.853 0 001.855-1.858 9.285 9.285 0 00-9.284-9.284zM22.997 26H2.713a.144.144 0 01-.142-.145c0-4.173 3.396-7.57 7.57-7.57h5.426c4.179 0 7.575 3.397 7.575 7.57 0 .08-.064.145-.145.145z"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_603_2035">
					<path
						fill="#fff"
						d="M0 0H34.286V27.429H0z"
						transform="translate(.857 .286)"
					></path>
				</clipPath>
			</defs>
		</svg>
	);
}